import React from 'react'
import Spinner from './Spinner'


export default function FullPageSpinner() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
      }}
    >
      <Spinner />
    </div>
  )
}
